import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import { observable } from 'mobx';
import Video from '@src/components/video';
import { noop } from '@src/utils/common-util';
import { getBackgroundMusic } from '@src/components/audio';
import { useEffect } from 'react';
import Toast from '@src/components/toast';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import getPageLocalesData, { getLocales } from '@src/global-locales/get-page-locales-data';
import { mechaData } from './mechaUnit';
import { jumpPage } from '@src/utils/common-util';
const pageLocalesData = getPageLocalesData();

const styles = require('./index.less');
class MechaUnitStore extends BaseStore {
  @observable isActive = false;
  closeVideoModal = noop; // 关闭视频弹窗

  @observable pageData;

  // 语音TAB
  @observable cvTab;

  @observable isShowBackTop = false;

  // cv数据
  @observable cvList;

  // 当前cv音频
  @observable currentCvAudio;
  // 语音当前播放的角标
  @observable cvIndex;
  // 当前音频是否播放
  @observable currentAudioState;
  // 语音tab角标
  @observable cvTabIndex = 0;

  // 切换语音tab
  switchCvTab(i, lang) {
    this.cvTabIndex = i;
    if (lang === '中文') {
      this.cvList = this.mechaData?.zhCvList;
    } else if (lang === '英语') {
      this.cvList = this.mechaData?.enCvList;
    } else {
      this.cvList = this.mechaData?.jaCvList;
    }
    this.bgmAudio && this.bgmAudio.stop();
  }

  // 点击播放音频
  onClickPlayRoleAudio(index) {
    this.cvIndex = index;
    this.cvList.forEach((cv, i) => {
      if (i !== index && cv.isPlay) {
        // 如果是其他项正在播放，则暂停它
        cv.isPlay = false;
      }
    });

    // 2. 切换当前点击项的播放状态
    this.cvList[index].isPlay = !this.cvList[index].isPlay;

    if (this.cvList[index].isPlay) {
      // 播放音频
      if (this.cvList[index].cvAudio_url === '') {
        return Toast.info(`${pageLocalesData.global.comming_soon}`);
      }

      this.currentCvAudio = this.cvList[index].cvAudio_url;
      this.bgmAudio.audio.src = this.currentCvAudio;
      this.bgmAudio && this.bgmAudio.play();
      this.currentAudioState = true;
    } else {
      this.currentAudioState = false;
      this.bgmAudio.stop();
    }
  }

  back = () => {
    if (!IS_DEV_ENV) {
      const url = 'index.html';
      jumpPage(url, '#/');
    } else {
      this.redirect('/');
    }
  };
  // 播放弹窗视频
  playVideo = () => {
    const { close } = Video.append({
      // src: 'https://static-www.mechabreak.cn/video/20231206/youxitese/youxitese02.mp4',
      src: this.mechaData.video_link,
      modalContainerClassName: styles.modalContainerClassName
    });
    this.closeVideoModal = close;
  };

  onResetAudioState = () => {
    if (this.cvIndex) {
      this.cvList[this.cvIndex].isPlay = false;
      this.currentAudioState = false;
    }
  };

  backTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  use() {
    super.use();

    const mechaUnitId = this.$routeMatch.query.id;

    const lang = getLanguageByPath();
    useEffect(
      () => {
        if (!mechaUnitId) {
          Toast.info(getLocales('global.comming_soon'));
          const timer = setTimeout(() => {
            this?.redirect('/');
            clearTimeout(timer);
          }, 500);
        }
        this.pageData = pageLocalesData.mechaUnit;

        // 获取语音数据
        const data = mechaData[mechaUnitId];
        if (data) {
          this.mechaData = data;
          if (lang === 'ja') {
            this.cvList = data?.jaCvList;
            this.cvTab = [
              {
                name: this.mechaData.cvJA,
                lang: pageLocalesData.mechaUnit.voiceTabJA
              },
              {
                name: this.mechaData.cvEN,
                lang: pageLocalesData.mechaUnit.voiceTabEN
              },

              {
                name: this.mechaData.cvCH,
                lang: pageLocalesData.mechaUnit.voiceTabCH
              }
            ];
          } else {
            this.cvList = data?.enCvList;
            this.cvTab = [
              {
                name: this.mechaData.cvEN,
                lang: pageLocalesData.mechaUnit.voiceTabEN
              },
              {
                name: this.mechaData.cvJA,
                lang: pageLocalesData.mechaUnit.voiceTabJA
              },
              {
                name: this.mechaData.cvCH,
                lang: pageLocalesData.mechaUnit.voiceTabCH
              }
            ];
          }
        }
      },
      [mechaUnitId]
    );

    useMount(async () => {
      if (!this.bgmAudio) {
        this.bgmAudio = getBackgroundMusic({
          src: this.currentCvAudio,
          loop: false,
          endedCb: this.onResetAudioState
        });
      }
    });

    useEffect(
      () => {
        if (this.cvList) {
          this.bgmAudio && this.bgmAudio.stop();
          this.onResetAudioState();
        }
      },
      [this.currentIndex, this.cvTabIndex]
    );

    useMount(async () => {
      this.isActive = true;

      const handleScroll = () => {
        this.isShowBackTop = window.scrollY > 100;
      };
      window.addEventListener('scroll', handleScroll);
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    });
  }
}

export default MechaUnitStore;
